export default {
    orderHistory: "Order History",
    collectionForYou: 'COLLECTION FOR YOU',
    color: 'Color',
    size:"Size",
    selectAddressFordelivery: 'Select address for delivery',
    deliveryAddress: 'Delivery Address',
    deliveryDate: 'Delivery Date',
    addNewAddress: 'Add New Address',
    changeAddress: 'Change Address',
    viewAllProducts: 'View All Products',
    viewAllComments: 'View All Comments',
    searchItem: "Search",
    view_detail: "View Detail",
    home: "Home",
    category: 'Category',
    tvShop: 'TV Shopping',
    live : "Live",
    order: 'Order',
    group: 'Group',
    notice: 'Notice',
    comments: "Comments",
    productAtCheapPrice: 'Attractive products at low prices',
    seeAll: 'View All',
    all: "All",
    peopleHaveBrought: 'People have bought',
    myPrice: 'My Price',
    clearanceSale: 'CLEARANCE SALE',
    under100: 'Under Rs 100',
    newCollection: 'NEW COLLECTION',
    trendingProducts: 'TRENDING PRODUCT',
    contactNo: 'Contact No.',
    mall91Ai: 'Mall91 AI',
    whatDoUWant: 'What do you want to buy',
    mall91ShoppingService: 'Mall 91 Shopping Service',
    clickHere: 'Click here',
    browserNotSupportVideoTag: 'Your browser does not support the video tag.',
    contactUs: 'Contact Us',
    deliveryPolicy: 'Delivery Policy',
    freeShipping: 'Free Shipping',
    freeShippingMsg:'Free Shipping - Goods will be delivered to you for free!',
    shippingType:'Shipping Type',
    freeGift: 'Free Gift',
    buy: 'Buy',
    share: 'Share',
    company: 'Company',
    doShare: 'Please Share',
    downloadApp: 'Download App',
    lastVideos: '',
    liveTv: 'Live Tv',
    viewProduct: 'View Product',
    sales: 'Sales',
    availableItemNumber: 'Available item number',
    buyProduct: 'Buy product',
    preLive: 'Pre live',
    nextLive: 'Next live',
    seeDetail: 'See Detail',
    noProductForThisCategory: 'No products were found for this category',
    congrats: 'congratulation',
    gotYourOrder: 'We received your order',
    paidAmount: 'Payment amount',
    yourOrderId: 'Your order ID',
    seeproduct: 'View product',
    paymentFailed: 'Payment failed',
    yourPendingOrders: 'Your Pending Orders',
    yourOrders: 'Your orders',
    buyOnChat: 'Buy on chat',
    extraDiscountOnOrder: 'Extra discount of ₹ {cost} ',
    buyOnPaytm: 'Buy from paytm',
    yourAddress: 'Your address',
    paymentMode: 'Payment Mode',
    cancel: 'Cancel',
    ordered: 'Ordered',
    delivery: 'Delivery',
    delievered: 'Order delivered',
    paymentStatus: 'Payment Status',
    pleaseWait: 'Please wait',
    gettingYourPayment: 'Your payment is being taken',
    sellingPrice: 'cost price',
    walletDiscount: 'Wallet Discount',
    mCashDiscount: 'Mcash Discount',
    onlineDiscount: 'Online Discount',
    cutFromFriendPrice: 'Cut from friends price',
    groupDiscount: 'Group Discount',
    youWillPay: 'You will pay',
    tellDeliveryAddress: 'Specify delivery address',
    postOffice: 'Post office',
    city: 'City',
    state: 'State',
    landMark: 'Landmark',
    fullName: 'Full name',
    mobile: 'Mobile',
    courierPartnerWillContact: 'Your number where the courier will contact you',
    payment: 'Payment',
    paytmPayment: 'Paytm payment',
    onlinePayment: 'Online payment',
    codPayment: 'COD Payment',
    cashOnDelivery: 'Cash on delivery',
    buyOnCall: 'Buy on call',
    doOrder: 'Order',
    yourPreOrder: 'Your pre order',
    tellCustomerSupporter: 'To place an order, tell your call operator your pre-order ID.',
    pleaseCall: 'Please Call',
    seller: 'Seller',
    lessAMount: 'Lose money',
    shareAndEarn: 'Share Now',
    buyInGroup: 'Buy in group',
    productBreak: '',
    costPrice: 'cost price',
    shippingTime: 'Shipping time',
    refund: 'Refund',
    peopleBuyInGroup: 'Group purchase of people',
    createdShoppingGroup: 'Shopping groups are created',
    plaeseJoin: 'Plaese Join',
    aboutProduct: 'About product',
    cashBackOnFriendPurchase: "हर खरीद पर कैश पाएं, पूरे 15 लेवल तक",
    addWhatsappMobileNUmbe: 'Add mobile number to buy from whatsapp',
    openMall91Shop: 'Open mall 91 shop',
    getCommisionFromPurchaseOnFamily: 'Order this product from friends and family and get commission on every sale',
    getCommision: 'Earn profit',
    seeHow: 'How to watch',
    seeAllComment: 'See all Comments',
    doComment: 'Write Comment',
    liked: 'Liked',
    peopleLiked: 'People Liked',
    peoplecomments:'People Commented',
    writeComments: 'Write comments here...',
    youAndotherPeopleLiked: '',
    seeAllLikes: 'See all likes',
    like: 'Likes',
    buyOnWhatsapp: 'Buy on whatsapp',
    whoCut: 'Who cut',
    productReturnPolicy: 'Item return service',
    whyReturningThisProduct: 'Why are you returning this product?',
    chooseOption: 'Select selected option',
    tellYourProblemHere: 'Write your reason here…',
    viewReturnDetail: 'View return details',
    priceDetail: 'Price Detail',
    everyProductOnDiscount: 'All goods at huge discount',
    freeShippingOnEveryProduct: 'Free shipping on everything',
    returnAndRefundPolicy: 'Return and Refund Policy',
    chooseMall91Center: 'Choose your city mall 91 center',
    getOrderFrom1Click: 'Take order number in 1 click on whatsapp',
    payAmountAndPickOrder: 'Pay cash and pick up orders at Mall 91 Center',
    availableCity: 'Available cities',
    mCash: 'MPoints',
    shareANdEarn5Mcash: 'Share ₹. 5 / Referral',
    chat: 'Chat',
    appLiked: 'Liked',
    ratingText: 'Help us so that you can earn more. Give us 5 stars so that the network can grow.',
    giveStarRating: 'Give 5 stars rating',
    notNow: 'Not Now',
    complainText: 'Something went wrong? Mail the link to the solution.',
    selectSize:"Select Size",
    selectColor:"Select Color",
    customerSupporter:"Customer Support",
    trendingProd:"TRENDING PRODUCT",
    shareAndEarnInNetwork:"Share and earn",
    shareAndEarnfivePerson:"Share with only 5 people and you can earn 1 lakh rupees",
    delivary:"The product will reach you in 10-15 days! Our goods come from outside!",
    paymentViaCash: 'You can pay with cash on this product',
    paymentOnline: 'You can pay online for this product',
    relatedProduct:"Related Products",
    buyOnline:"Buy Online",
    productList: 'Product List',
    orderDetail: 'Order Detail',
    productReturn: 'Product Return',
    shippingDetail: 'Shipping Detail',
    paymentDetail: 'Payment Detail',
    productDetail: 'Product Detail',
    playAndWin: 'Now shop while playing and get extra discounts!',
    createAGroup: 'Create a Group',
    invitefriends: 'Invite Friends',
    completeGroup: 'Complete Group',
    saveTogether: 'Save Together',
    selectProduct: 'Select Product',
    addYourFriend: 'ADD Your Friends',
    lessAmount: 'Get Price Less',
    getInFree: 'Get in free',
    onBuyGetDiscount: '₹ {discountPrice} off on group purchase of {memberCount} people',
    startGroup: 'Join Now',
    groupOnProduct: 'Group on Product',
    totalMember: 'Total Members',
    groupDiscount: 'Group Discount',
    sold: 'Purchase done',
    saleLeft: 'Purchase pending',
    discountExpire: 'Expires in',
    buyNow: 'Buy Now',
    createGroup: 'Create group',
    from: 'from {location}',
    membersJoined: 'Group Formed',
    purchaseDone: 'Purchase Done',
    outOfStock:'Product is out of stock',
    spreadSomeLove: 'Would you like to spread some love ? ',
    rateNow: 'Rate Now',
    later: 'Later',
    singleBuy: 'Single Buy',
    groupBuy: 'Buy in Group',
    buyOptionNote: 'How do you want to buy the product ? Select from options',
    priceForsingleBuy: '₹ {singlePrice}',
    priceForGroupBuy: '₹ {groupPrice}.0',
    shoppingGame:'Shopping Game',

    helpcentere: 'For any assistance you can contact our Customer Support Center.',
    plzEmail: 'Email:',
    plzCall: 'Call:',
    callHours: 'Calling hours are Monday to Saturday, 10 am to 7 pm.',
    all: 'All',
    value: 'value :',
    noMoreRecord: 'No more records available',
    noRecords: '',
    company: 'COMPANY',
    aboutUs: ' About Us',
    contactUs: 'Contact Us',
    polices: 'Policies',
    deliveryPolicy: 'Delivery Policy',
    disclaimerPolicy: 'Disclaimer Policy',
    privacyPolicy: 'Privacy Policy',
    returnAndrefund: 'Return & Refund Policy',
    availableItemNumber: 'Available item number',
    send: 'send',
    buyProduct: 'Buy Product',
    discountPrice: 'Discount Price',
    buyNow: 'Buy Now',
    peopleBoughtThisDeal: "{people} people have purchased",
    Rs: "Rs",
    noProductForThisCategory: 'No products were found for this category',
    yourPendingOrders: 'Incomplete orders',
    yourOrders: 'Your orders',    
    notice: 'Notice',
    situation: 'status',
    groupExpired: 'Group Expired',
    mall91ShoppingService: 'Mall 91 Shopping Service',
    browserNotSupportt: 'Your browser does not support the video tag.',
    clickHere: 'Click here',
    addMall91: 'Add Mall91 to Home Screen',
    getThisItem: 'Now get this item only in {value} Rs',
    getThisFree: 'Now get this item in {value}',
    addNow: 'Join now',
    modeToReturnPayment: 'Which mode do you want to pay back?',
    paytmDetail: 'Paytm Detail',
    submit: 'Submit',
    bankDetail: 'Bank Detail',
    orderId: 'Order Id :',
    status: 'Status',
    totalAmtPaid: 'Total amount to be paid',
    tokenNo: 'Token Number',
    nearAgent: 'Go to your nearest agent',
    seeList: 'Click on the button below to see the list of nearby agents.',
    shareToken: 'Share your token number with agent',
    getToken: 'You can take the Token number from above. Token number will also be sent to you on message.',
    payToAgent: 'Pay in cash with agent',
    paymentSucces: 'Your payment will be approved as soon as you make a payment.',
    settlepayment: 'To settle payment',
    findNearAgent: 'Find NearPe agents near you below',
    findAgent: 'Find Agents',
    color: 'Color',
    size: 'Size',
    seller: 'Seller',
    colorPrintsMayvary: 'Colors and prints may vary slightly due to lighting.',
    reachIn15Days: 'Goods will reach you in 15 days!',
    priceDetail: 'Price Detail',
    costPrice: 'Cost Price',
    shippingCharges: 'Shipping cost',
    walletDiscount: 'Wallet Discount',
    mpointsDiscount: 'MPoints discount',
    onlineDisc: 'Online discount',
    cutFromFriendPrice: 'Cut from friends price',
    extraDiscount: 'Extra discount',
    groupDiscount: 'Group Discount',
    delivery: 'Delivery',
    totalAmount: 'Total Amount',
    congrats: 'Congrats!',
    gotYourOrder: 'We received your order.',
    paymentFailed: 'Payment failed',
    yourOrderId: 'Your order ID',
    tryAgain: 'Try again',
    paymentStatus: 'Payment Status',
    plzWait: 'Please wait ...',
    takingPayment: 'Getting your payment ...',
    tellDeliveryAddress: 'Provide Delivery Address?',
    "Pincode*": "Pincode*",
    postOffice: 'PostOffice',
    city: 'City',
    state: 'State',
    landMark: 'Land Mark',
    fullName: 'Full Name',
    mobile: 'Mobile',
    courierPartnerWillContact: '* Your number where the courier will contact you',
    address: 'Address',
    payment: 'Payment',
    paytmPayment: 'Paytm Payment',
    debitOrNet: 'Debit card or netbanking',
    cashOnDelivery: 'Cash On Delivery',
    notAvailableCod: 'Cash on delivery not available',
    nearPePayment: 'NearPe - Deposit Cash at the nearest store',
    chooseCOD: 'You have chosen the COD option.',
    CODMsg: 'Your order will arrive in 10-15 days! Cash on delivery - You have to pay ₹ {preorderTotalAmount} when the goods arrive!',
    codServiceNotAvailable: 'COD facility is not available on your pincode.',
    msgForNotAvailCOD: "The COD option has been removed for you as you refused to take the previous COD order. This option will be enabled again when one order is successfully accepted by you.",
    doOrder: 'Order Now',
    whyReturningThisProduct: 'Why are you returning this product?',
    chooseOption: 'Select option',
    viewreturnDetails: 'view return details',
    paymentMode: 'Payment Mode',
    online: 'Online',
    courierOnGivenAddress: 'Please courier this item to the address given below - Your payment will be refunded along with the courier price as soon as the item is received.',
    roviri91: 'Rovi91 Innovations Pvt Ltd 1st floor Plot 140 Patparganj Industrial Area Delhi',
    Delhi11: 'Delhi - 110092',
    pleasePackUrCourierOrder: 'Please pack the item! Our courier partner {PersonName} will pick up the item',
    addBankDetails: 'Add Bank Detail',
    shippingDetails: 'Shipping Details',
    mobileNumber: 'Mobile Number',
    returnItem: 'Return Order',
    trackOrder:'Track Your Order',
    cancelOrder: 'You want to cancel this order!',
    cancel: 'Cancel',
    congratulations: 'Congratulations!',
    orderCancel: 'Cancel Order',
    mode: 'Mode',
    ordered: 'Ordered',
    delievered: 'Delivered',
    shippingExtraCost: 'Shipping extra cost',
    changeLanguage: 'Change language',
    changeYourLanguage: 'Change Your Language',
    lastliveVideos: 'View videos of earlier added product',
    allVideos:'All Videos',
    preLive: 'Prev Live',
    nextLive: 'Next Live',
    live: 'Live',
    host: 'Host',
    with: 'with',
    commimgLiveVideo: 'Upcoming Live Video on Products',
    next: 'Next',
    seeDetail: 'See Detail',
    highQuality: 'High Quality',
    lowQuality: 'Low Quality',
    aboutUsRule1: 'Shop in your city now on your mobile - the best and cheapest item in India - that you will not be able to live without buying!',
    aboutUsRule2: '★ Unique products - such that you will not find even in your city - and at prices that will blow your senses',
    aboutUsRule3: '★ Watch Live Shows of Products - Daily with our Smart Hosts - Just like TV - Understand Products - Chat with Users with Comments',
    aboutUsRule4: 'Order easily on WhatsApp in 1 click - Write your name address on WhatsApp or speak in voice message',
    aboutUsRule5: 'Pay in WhatsApp - many ways - WhatsApp Pay, or Paytm, or Google Pay, or Bhima UPI, or debit card via 1 payment link',
    aboutUsRule6: 'Or pay with cash - to book an order in your city mall 91 center - and pick up your order from there - available in select cities only(and coming soon to all cities)',
    aboutUsRule7: 'Get prepaid orders at your home, get cash payment orders from your city mall 91 center',
    aboutUsRule8: 'Earn cash on every friends purchase - just share the products links on WhatsApp with your friends - get cash on every friends purchase - and you will alsoget 1 part of their earnings on sharing in front of friends!',
    aboutUsRule9: 'App less than 4MB in size',
    aboutUsRule10: 'Join our WhatsApp group and get 1 new bangla deal everyday - which you will not get anywhere in India - share the link of WhatsApp group with friends too, because you will get huge discounts in buying deals with friends!',
    roviri: 'Rovi91 Innovations Pvt Ltd',
    addressMall91: 'Address - 311, Mamram East Plaza, Plot No 192, Sector G, Mayur Vihar, Phase 3, Delhi - 110096',
    freeShipping: 'Free Shipping',
    deliveryRule1: 'Rovi91 Innovations Pvt Ltd provides free shipping on all items if your total order amount is more than Rs. 10,000. Otherwise we charge Rs. 50 as shipping charges.',
    deliveryRule2: 'All items get delivered within 1 day of receipt of order.',
    deliveryRule3: 'With every order, you will receive an email and mobile app notification containing the details of the order placed by you. Once the items are shipped, you will receive another email and mobile app notification containing the shipping details. You can also access My Orders  on site or mobile app to see the details of all your placed orders.',
    deliveryRule4: 'Our prices are all inclusive. All taxes are indicated separately with the listed prices.',
    disclaimerRule1: "The information contained in this website is for general information purposes only. This information has been given by Roviri Innovations Pvt Ltd, the property of Roviri Innovations Pvt Ltd. As long as we try to keep the information up to date and correct, we do not make any representation or warrant about the completeness, expressed or implied, about the accuracy, reliability, suitability or availability of the website or information. , Products, services, or related graphics are contained for any website purpose. Any dependence given by you on such information is strictly at your own risk.",
    disclaimerRule2: "IN NO EVENT SHALL WE BE LIABLE FOR ANY LOSS OR DAMAGE, INCLUDING INDIRECT OR CONSEQUENTIAL DAMAGE OR DAMAGE, OR ANY LOSS OR DAMAGE THAT MAY BE INCURRED FROM THE LOSS OR PROFITS OF DATA, OR WITH RESPECT TO, Website access.",
    disclaimerRule3: "Through this website you are able to link to other websites which are not under the control of Roviri Innovations Private Limited. We have no control over the nature, content and availability of those sites. The inclusion of any link does not necessarily imply a recommendation or endorse the views expressed within them.",
    disclaimerRule4: "Every effort is made to make the website run smoothly. However, Roviri Innovations Private Limited has no responsibility, and the website will remain temporarily unavailable due to technical issues beyond our control.",
    privacyRule1: 'This Privacy Policy is effective as of March 2019.',
    privacyRule2: 'Rovi91 Innovations Pvt Ltd provides this Privacy Policy to inform users of our policies and procedures regarding the collection, use and disclosure of personally identifiable information received from users of this website, located at Rovi91 Innovations Pvt Ltd ("Site" ) or collected through our service, including via SMS, WAP and Instant Messaging ("Service" ). This Privacy Policy may be updated from time to time for any reason; each version will apply to information collected while it was in place. We will notify you of any material changes to our Privacy Policy by posting the new Privacy Policy on our Site. You are advised to consult this Privacy Policy regularly for any changes.',
    privacyRule3: 'By using our Site you are consenting to our processing of your information as set forth in this Privacy Policy now and as amended by us. "Processing" means using cookies on a computer or using or touching information in any way, including, but not limited to, collecting, storing, deleting, using, combining and disclosing information, all of which activities will take place in India. If you reside outside India your personally identifiable information will be transferred to India, and processed and stored there under Indian privacy standards. By visiting our Site and providing information to us, you consent to such transfer to, and processing in India.',
    privacyRule4: 'if you have any questions or comments about this Privacy Policy or our use of your personally identifiable information, please contact us at help@mall91.com',
    privacyRule5: 'Our primary goals in collecting personally identifiable information are to provide you with the product and services made available through the Site, including, but not limited, to the Service, to communicate with you, and to manage your registered user account, if you have one.',
    privacyRule6: 'If you desire to have access to certain restricted sections of the Site, you will be required to become a registered user, and to submit certain personally identifiable information to Rovi91 Innovations Pvt Ltd. This happens in a number of instances, such as when you sign up for the Service, or if you desire to receive marketing materials and information. Personally identifiable information that we may collect in such instances may include your IP address, full user name, password, email address, city, time zone, telephone number, and other information that you decide to provide us with, or that you decide to include in your public profile.',
    privacyRule7: "Your full user name and your photo, if you decide to upload one, are displayed to people in the Rovi91 Innovations Pvt Ltd network to enable you to connect with people on Rovi91 Innovations Pvt Ltd, as specified in your privacy settings. Once a member, you may provide additional information in the profile section, including but not limited to your bio, your location, as well as your personal web site, if you have one. Providing additional information beyond what is required at registration is entirely optional, but enables you to better identify yourself and find new friends and opportunities in the Rovi91 Innovations Pvt Ltd system. If you provide your mobile phone number, we will collect your mobile number and store it in our database. You will receive notifications on your mobile phone account in a number of cases, such as when a Rovi91 Innovations Pvt Ltd member sends you an offer for your posted item or an item is posted which is in your wish list or Rovi91 Innovations Pvt Ltd Your full user name and your photo, if you decide to upload one, are displayed to people in the Rovi91 Innovations Pvt Ltd network to enable you to connect with people on Rovi91 Innovations Pvt Ltd, as specified in your privacy settings. Once a member, you may provide additional information in the profile section, including but not limited to your bio, your location, as well as your personal web site, if you have one. Providing additional information beyond what is required at registration is entirely optional, but enables you to better identify yourself and find new friends and opportunities in the Rovi91 Innovations Pvt Ltd system. If you provide your mobile phone number, we will collect your mobile number and store it in our database. You will receive notifications on your mobile phone account in a number of cases, such as when a Rovi91 Innovations Pvt Ltd member sends you an offer for your posted item or an item is posted which is in your wish list or Rovi91 Innovations Pvt Ltd team has any announcement to make etc. If you contact us by email through the Site, we may keep a record of your contact information and correspondence, and may use your email address, and any information that you provide to us in your message, to respond to you.team has any announcement to make etc. If you contact us by email through the Site, we may keep a record of your contact information and correspondence, and may use your email address, and any information that you provide to us in your message, to respond to you.",
    privacyRule8: 'In addition, we may use your contact information to market to you, and provide you with information about, our products and services, including but not limited to our Service. If you decide at any time that you no longer wish to receive such information or communications from us, please follow the unsubscribe instructions provided in any of the communications.',
    privacyRule9: "Whenever you visit a website ('log data'), our server automatically records the information sent by your browser. This log data may include your IP address, browser type, or information from the domain you're visiting, the web-pages you've visited, the search terms you've used, and any clicks you've clicked advertisement. For most users accessing the Internet from an Internet service provider, when you log on, the IP address will vary. We use log data to monitor the use of the site and our service, and for technical administration of the site. We do not associate your IP address with any other personally identifiable information to identify you personally except as a violation of the Terms of Service",
    privacyRule10: "Like many websites, we also use cookie technology to collect additional website usage data and improve the site and our service. A cookie is a small data file that we transfer to your computer (TM) hard disk. We do not use cookies to collect personally identifiable information. {0} Sessions can use both cookies and persistent cookies to better understand how you interact with the site and our service, the use of the site by our users and web traffic routing on the site and the site and our services To improve. A session cookie enables certain features of the site and our service and is removed from your computer when you disconnect or leave the site. Even after you close your browser, a permanent cookie remains and can be used by your browser on visits to the site. Cookies can be removed continuously by following your web browser help file instructions. Most Internet browsers automatically accept cookies. You can instruct your browser, by editing its options, to stop accepting cookies or to prompt you before accepting cookies from the websites you visit.",
    privacyRule11: "Service Providers We engage certain trusted third parties to act and provide services to us, including, without limitation, hosting and maintenance, customer relationships, database storage and management, and direct marketing campaigns. We will share your personally identifiable information with these third parties, but to the extent necessary to perform these functions and to provide such services, and only to maintain the confidentiality and security of your data, such third To comply with contractual obligations requiring parties.",
    privacyRule12: "Collaborates with the government and law enforcement officers or private parties to enforce and follow the law. We may disclose any information about you to the government or law enforcement officers or private parties, as we may, in our sole discretion, require the legal or proper sub-process (including sub-sections) to make a claim ), To protect the property and rights of {0}. Or third party, to prevent or prevent any illegal, unethical, or legally actionable activity, or the protection of the public or a person to obey the law.",
    privacyRule13: "Roviri Innovations Pvt Ltd may sell, transfer or otherwise share some or all of your assets, including your personally identifiable information, in the event of a merger, acquisition, reorganization or sale of assets or bankruptcy. You will have the opportunity to opt out of any such transfer if the new entity's planned processing of your information differs from that set out in this Privacy Policy.",
    privacyRule14: "If you are a registered user of the site, you can update and update the information you have provided to us or e-mail us at help@mall91.com.",
    privacyRule15: "Roviri Innovations Pvt Ltd is very concerned about securing the confidentiality of your personally identifiable information. We employ administrative, physical and electronic measures designed to protect your information from unauthorized access.",
    privacyRule16: "",
    privacyRule17: "Our site contains links to other websites. The fact that we link to a website does not endorse, authenticate or represent our affiliation with that third party. We do not control third party websites. These other websites may place their cookies or other files on your computer, collect data or personally identifiable information from you. Other sites follow various rules regarding the use or disclosure of personally identifiable information submitted by you. We encourage you to read the privacy policies or statements of other websites you visit.",
    privacyRule18: "We may disclose third party services to some personally identifiable information listed below:",
    privacyRule19: "320/5000 The information you provide to us such as name, email, mobile phone number information that we collect and use our service, including device information, location, and network carriers, this information to third parties Shared with service providers so that we can: Personalize the app for You conduct behavior analysis.",
    privacyHeading1: '1. Information Collection and Use',
    privacyHeading2: '2. Information Collected Upon Registration',
    privacyHeading3: '3. Additional Information',
    privacyHeading4: '4. Use of Contact Information',
    privacyHeading5: '5. Log Data When you visit the Site',
    privacyHeading6: '6. Cookies',
    privacyHeading7: '7. Information Sharing and Disclosure',
    privacyHeading8: '8. Compliance with Laws and Law Enforcement',
    privacyHeading9: '9. Business Transfers',
    privacyHeading10: '10. Changing or Deleting Information',
    privacyHeading11: '11. Security',
    privacyHeading12: '12. Links to Other Websites',
    privacyHeading13: '13. Information Disclosure',
    returnRule1: "Return and Return Policy: You have the right to cancel your order within 7 working days from delivery. You should notify us by email of your intention to cancel within 7 working days from delivery.",
    returnRule2: "The goods must be returned 'AS Sold' in original condition.",
    returnRule3: "Goods must be complete, unused, and in 'AS NEW' condition (eg if you have opened the box to examine that product without damaging the box and packaging or damaging the product in any way. Must go) and be re-received as package.",
    returnRule4: "Must be returned within 7 days from Goods Authority to our Returns Department. We are unable to accept returns of non-wanted and non-defective items after 7 days.",
    returnRule5: "Any 'free GIFs' with products must also be returned.",
    returnRule6: "265/5000 You have to organize the return of unwanted items at your expense and risk. Return authorization is valid for 7 days only. Goods sent back without prior return authorization will be returned to you and the cost of delivery delivered to your account.",
    returnRule7: "The full refund of the cost of the goods is fully conditional on the above conditions and the authorized refund only after thorough inspection of the goods by our Returns Department to check for completeness and correct product return.",
    returnRule8: "Goods returned as new and unused and in unused condition: full invoice amount will be returned to you.",
    returnRule9: "Goods not received back, which is not in a resuscitation condition: We are unable to accept these back under the above conditions and the goods will be returned to you and the cost of delivery delivered to your account.",
    returnHeading1: 'please pay attention',
    returnHeading2: 'Refund',
    howToBuy: 'How to buy',
    seeMore: 'See more ..',
    clearFilter: 'Clear Filter',
    filter: 'Filter',
    apply: 'Apply',
    fromTo: 'from to',
    productTerm: 'Product Purchase Terms and Conditions',
    getDeal: '★ Purchase of total {minOrderId} people will get this group deal',
    makePayment: '★ It is necessary to pay the deal price first',
    refundMoney: '★ If the group deal is not completed, the entire payment will be refunded to your account',
    goAhead: 'Go ahead',




    addFriends: 'Add friends and reduce the price. Get this product for FREE',
    shareWithFrnds: 'Share with friends',
    cutPrice: 'Cut the Price',
    seeMoreProduct: 'See More Products',
    whoLoseMoney: 'See who has reduceed money',
    people: 'People',
    from: 'from {location}',
    nowYourProductPrice: 'Wow! Your item is now priced at {cost}',
    thatMuchLeft: '{price} rupees left',


    noMoreResult: 'no more results',
    createGroupCon: 'Terms and conditions for grouping',
    totalDeal: '★ Total {{$ props.minOrderData}} people will get this group deal',
    sold: 'SOLD',
    off: 'OFF',
    getCash: 'Share this Product in your network and get a commission on every purchase.',
    pleaseChoosePaymentOption: 'Please select payment options !',
    paymentSelectMessage: 'You have not selected any payment option. Please select payment option to proceed.',
    okText: 'ok',
    mall: 'Mall',
    onlineDiscountOnProd: '₹ {cost} extra discount on online payment',
    orderDate: 'Order date',
    currentState:'Order State',
    groupListing:'Group Listing',
    cutThePrice:'Cut the Price',
    trackOrderHead:'TrackOrder',
    prductComment:'ProductComment',
    orderTrackingDetail: 'Order Tracking details',
    courierServiceName: 'Courier Service Name',
    trackingNumber: 'Tracking Number',
    otpNumber: 'OTP Number',
    partnerName: 'Partner Name',
    courierContactNo: 'Contact Number',
    trackYourOrder: 'Track your order at',
    yes: 'Yes',
    doYouReallyWantToCancel: 'Do You really want to cancel this order ?',
    orderCancelMsg: 'The item shown above will be canceled and you will not be able to take advantage of this item. If you do not want to cancel, you can have this item delivered to your door.',
    won: 'Won',
    boughtFrom: '{user} bought from {city} and'
}